import React from "react";
import Imgix from "react-imgix";
import { ButtonStd } from "../Buttons";
import { endSlash } from "../../util/helperFunctions";

// This banner is only used on the Homepage
const HomepageBanner = ({ page, exploreDowntown }) => {
  return (
    <div className="banner--home bg-blue relative">
      {page.bannerImage && (
        <div className="absolute top-0 left-0 h-100 w-100">
          <Imgix
            src={endSlash(page.bannerImage.url)}
            className="bg-center image-cover mb0 h-100 w-100"
            imgixParams={{
              "max-w": 2732,
              "max-h": 600,
              "fp-x": page.bannerImageFocalPointX,
              "fp-y": page.bannerImageFocalPointY,
              auto: ["compress"],
              fit: "crop",
              crop: "focalpoint"
            }}
            htmlAttributes={{
              alt: page.bannerImageAltText
            }}
          />
        </div>
      )}
      <div className="flex flex-column h-100 justify-end">
        <h1 className="banner--home__headline white h-2 h-1--l mb0 z-1">
          {page.title}
        </h1>
      </div>
    </div>
  );
};

export default HomepageBanner;



// WEBPACK FOOTER //
// ./src/components/Banners/HomepageBanner.js